import { apiHelper } from './api_helper';

export const danTocApi = {
    SelectAll: () => apiHelper.get('dan-toc')

}
